export default "__VITE_ASSET__a59aee9e__"